import { render, staticRenderFns } from "./TooltipMethod.vue?vue&type=template&id=49752b82&"
import script from "./TooltipMethod.vue?vue&type=script&lang=js&"
export * from "./TooltipMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports